import { ref, onMounted, onUnmounted } from 'vue';

import { BREAKPOINTS } from './breakpoints';


export default function useWindow() {
  const screenWidth = ref(window.innerWidth);

  onMounted(() => {
    window.addEventListener('resize', updateScreenWidth);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateScreenWidth);
  });

  function updateScreenWidth() {
    screenWidth.value = window.innerWidth;
  }

  return {
    BREAKPOINTS,
    screenWidth,
  }
}